import { ReactElement } from "react";
import Head from "next/head";
import { MainLayout } from "@/containers/layout/KoachLayout";

import FaqMainPage from "@/components/faqs/FaqMainPage/FaqMainPage";

const FAQs = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Frequency Asked Questions about Klink</title>
        <link rel="canonical" href="https://www.klink-app.com/faqs" />
        <meta
          name="description"
          content="Find quick answers to common questions about the Klink super app for future and existing home owners on our comprehensive FAQs page. Get the help you need now!"
        />

        <meta
          name="twitter:card"
          content="Find quick answers to common questions about the Klink super app for future and existing home owners on our comprehensive FAQs page. Get the help you need now!"
          key="twcard"
        />
        <meta name="twitter:url" content="https://www.klink-app.com/faqs" />
        <meta
          name="twitter:title"
          content="Frequency Asked Questions about Klink"
        />
        <meta name="twitter:image" content="/meta-opengraph-faqs.png" />
        <meta name="twitter:creator" content="klink_app" key="twhandle" />

        <meta
          property="og:url"
          content="https://www.klink-app.com/faqs"
          key="ogurl"
        />
        <meta property="og:url" content="/" key="ogurl" />
        <meta
          property="og:image"
          content="/meta-opengraph-guide.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Klink" key="ogsitename" />
        <meta
          property="og:title"
          content="Frequency Asked Questions about Klink"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Find quick answers to common questions about the Klink super app for future and existing home owners on our comprehensive FAQs page. Get the help you need now!"
          key="ogdesc"
        />
      </Head>
      <div className="bg-gradient-to-b md:bg-gradient-to-br from-navy from-70% md:from-60% to-magenta to-100% md:px-6 px-5 lg:px-11 xl:px-52 py-10 md:py-16 lg:py-20">
        <div className="flex gap-6 flex-col justify-center items-center">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-white">
              Frequently Asked Questions
              <p className="w-full text-xl md:text-2xl text-light-White text-center font-thin mt-3 md:mt-5 max-w-md  md:max-w-xl lg:max-w-3xl leading-normal">
                Answers to common questions about Klink.
              </p>
              <p className="w-full text-xl md:text-2xl text-light-White text-center font-thin mt-3 md:mt-5 max-w-md  md:max-w-xl lg:max-w-3xl leading-normal">
                If you can't find the answer you're looking for, feel free to{" "}
                <a
                  href="mailto:hello@klink-app.com"
                  target="_blank"
                  className="underline"
                >
                  contact our team
                </a>{" "}
                for further assistance.
              </p>
            </h1>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <FaqMainPage />
      </div>
    </>
  );
};

FAQs.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default FAQs;
